import { ProjectStatus } from "@src/types";
import { startCase } from "lodash";
import StatusNode from "./StatusNode";
import { getProjectStatusRenderingOptions } from "../projectRenderingOptions";

export default function ProjectStatusNode({
  status,
  fill,
  hasBackground = true,
}: {
  readonly status: ProjectStatus;
  readonly fill?: boolean;
  readonly hasBackground?: boolean;
}) {
  const { bgColor, icon, iconColor } = getProjectStatusRenderingOptions(status);
  return (
    <StatusNode
      fill={fill}
      icon={icon}
      iconColor={iconColor}
      title={startCase(status)}
      bgColor={hasBackground ? bgColor : undefined}
      dataTestId="project-status-node"
    />
  );
}
